import { AuditModel } from "./auditModel";
import { Address } from "./contacts";

export class EntityDetail extends AuditModel {
  public entityId: number;
  public clientId: number;
  public childEntityId: number;
  public isIndivisual: boolean;
  public isCorporate: boolean;
  public accountingFirmId: number;
  public trustType: string;
  public entityTypeId: any;
  public structure: boolean;
  public activities: string;
  public dueDate: Date;
  public relationshipTypeID :number;
  public entityName: string;
  public entityTypeName: string;
  public trustTypeId: number;
  public nameOfTrust: any;
  public trustCompanyName: string;
  public trusteeACN: string;
  public trusteeName: string;
  public trusteeAnniversaryDate: any;
  public trusteeType: any;
  public entityCode: string;
  public corporate:string;
  public bareTrusteeName: string;
  public bareTrusteeCompany: string;
  public bareTrusteeACN: string;
  public bareTrusteeABN: string;
  public bareTrusteeTFN: string;
  public bareTrusteeAnniversaryDate: any;
  public isBareTrustRequired: any = false;
  public trustTypeTFN: string;
  public trustTypeABN: string;
  public trusteeTypeTFN: string;
  public trusteeTypeABN: string;
  public trusteeTypeACN: string;
  public trusteeTypeTaxAgent: string;
  public taxFileNumber: string;
  public baretrustDetails=[];
  public TFN: string;
  public ABN: string;
  public ACN: string;
  public taxAgentId: string;
  public partnerId:string;
  public isGSTRegistered: boolean = true;
  public activityStatement: boolean = true;
  public engagementLetter: boolean = true;
  public lastlodgedTR: any;
  public lastlodgedBAS_IAS: any;
  public isAuditRequired: boolean;
  public lodgementDate: any;
  public referralsource: string;
  public softwareused: string;
  public managerId: string;
  public title: string='Not Determine'
  public firstName: string
  public lastName: string
  public gender: string='Not Determine'
  public dateOfBirth: any
  public homePhone: any
  public mobileNumber: any
  public workPhone: any
  public email: any
  public EntityBareTrust:EntityBareTrust[]=[]
  public addresses: Address[] = [];
  public isProspect: boolean = false;
}

export class EntityBareTrust extends AuditModel {
  public bareTrustId:number
  public entityId:number
  public trusteeType:string
  public childEntityId:number
  public clientId:number
  public bareTrustName:string
  public ABN:string
  public trustName:string
  public establishmentDate:Date
  public holdingAsset:string
  public trustType:string
  public specialPurposeCompany:string
}

export class EntityStatusDetail {
  public entityId: number
  public lastlodgedTR: string
  public referralsource: string
  public softwareused: string
}

export class EntityProfileDetail {
  public structure: boolean;
  public activities: string;
  public dueDate: Date;
  public relationshipTypeID: number;
}

export class EntityCreationDetail {
  public TrustTypeId: number;
  public entityTypeId: number;
  public entityName: string;
  public Prospect: boolean;
  public Filter: number;
}

export class EntityReferalSource {
  ReferalSourceID: any;
  ReferalSourceType: any;
  EntityId: any;
  name: any;
  contactPerson: any;
  address1: any;
  address2: any;
  organization: any;
  emailAddress: any;
  suburb: any;
  postCode: any;
  country: any;
  state: any;
  Created_By: any;
}

export interface EntityType {
    entityTypeId: number;
    entityTypeName: string;
}

export interface Tagsettings {
  catogery: number;
  entityTypeName: string;
}

export class ExternalEntityDetail {
  public entityId :number
  public clientId :number
  public accountingFirmId :number
  public entityTypeId :number
  public entityName :string
  public entityTypeName :string
  public trustCompanyName    :string
  public entityCode :string
  public TFN :string
  public ABN :string
  public ACN :string
  public taxAgent :string
  public isGSTRegistered :boolean
  public activityStatement :boolean
  public engagementLetter :boolean
  public lastlodgedTR :string
  public isAuditRequired :boolean
  public lodgementDate :Date
  public bankName :string
  public bankAccountName :string
  public bankAccountBSB :string
  public bankAccountNumber :string
  public created_By :string
}
